<template>
  <v-data-table
    :items="commits"
    :items-per-page="50"
    :loading="busy"
    :headers="headers"
    :footer-props="{'items-per-page-options':[15, 30, 50, 100, -1]}"
  >
    <template v-slot:item.sha="{ value }">
      <a
        target="_blank"
        :href="getCommitUrl(value)"
      >{{ value }}</a>
    </template>

    <template v-slot:item.balena_release="{ value }">
      <copyable-code
        :code="value"
        :length="7"
      />
    </template>

    <template v-slot:item.actions="{ item }">
      <ion-button
        :disabled="item.release"
        @click="release(item)"
      >
        <template v-if="item.release">
          Released
        </template>
        <template v-else>
          Release
        </template>
      </ion-button>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from 'vuex'
import { VDataTable } from 'vuetify/lib'
import { modalController } from '@modus/ionic-vue'

import CopyableCode from '../common/CopyableCode'
import Release from '../releases/Release'

export default {
  components: {
    VDataTable,
    CopyableCode
  },
  props: {
    project: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      busy: true
    }
  },
  computed: {
    ...mapGetters([
      'getCommitsForProject'
    ]),
    commits() {
      if(this.busy) {
        return []
      }

      return this.getCommitsForProject(this.project.id)
    },
    headers() {
      const headers = [
        {
          text: 'SHA',
          value: 'sha'
        },
        {
          text: 'Version',
          value: 'version'
        },
        {
          text: 'Build Number',
          value: 'build_number'
        },
        {
          text: 'Message',
          value: 'message'
        }
      ]

      if(this.project.name === 'Bridge') {
        headers.push({
          text: 'Balena Release',
          value: 'balena_release'
        })
      }

      headers.push({
        value: 'actions',
        sortable: false
      })

      return headers
    }
  },
  created() {
    this.fetchCommits()
  },
  methods: {
    fetchCommits() {
      if(this.project.id === 1) {
        this.busy = false
        // already been fetched while fetching project list
        return
      }

      this.$store.dispatch('fetchCommits', { project: this.project.id })
        .finally(() => this.busy = false)
    },
    getCommitUrl(sha) {
      return `${this.project.repository_base_url}/tree/${sha}`
    },
    async release(commit) {
      const modal = await modalController
        .create({
          component: Release,
          componentProps: {
            propsData: {
              commit
            }
          },
          cssClass: 'card-modal'
        })

      modal.present()
    }
  }
}
</script>
